import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const closeQuestion = async (questionId) => {
  const data = await request.get(
    `/Question/ask_to_close_question`,
    { questionId },
    'При отправке запроса на закрытие вопроса произошла ошибка',
    'Error'
  );

  return data;
};

const useCloseQuestionMutation = (options) => {
  return useMutation(({ questionId }) => closeQuestion(questionId), options);
};

export default useCloseQuestionMutation;
